import { PhoneOutlined, UserOutlined } from "@ant-design/icons";
import { HiOutlineMail } from "react-icons/hi";
import { Button } from "antd";
import React from "react";
import { LiaUserTagSolid } from "react-icons/lia";
import { t } from "i18next";

export const modalApplicantIntervenantInputs = ({
  setOpen,
  name,
  update = false,
  values = null,
}) => {
  return [
    {
      parentLabel:
        name === "applicant"
          ? t("modalApplicantIntervenantInputs.applicantInfo")
          : t("modalApplicantIntervenantInputs.responsableInfo"),
      children: [
        {
          placeholder: t("modalApplicantIntervenantInputs.lastName"),
          addonBefore: <UserOutlined />,
          name: name === "applicant" ? "info.lastname" : "lastname",
          value: values?.lastname,
          type: "input",
          required: true,
          col: 12,
        },
        {
          placeholder: t("modalApplicantIntervenantInputs.firstName"),
          addonBefore: <UserOutlined />,
          name: name === "applicant" ? "info.firstname" : "firstname",
          value: values?.firstname,
          required: true,
          type: "input",
          col: 12,
        },
        {
          name: name === "applicant" ? "info.phone" : "phone",
          addonBefore: <PhoneOutlined />,
          placeholder: t("modalApplicantIntervenantInputs.phone"),
          type: "input",
          value: values?.phone,
          col: 12,
        },
        {
          name: name === "applicant" ? "info.role" : "role",
          addonBefore: <LiaUserTagSolid />,
          placeholder: t("modalApplicantIntervenantInputs.role"),
          type: "input",
          value: values?.role,
          col: 12,
        },
        {
          addonBefore: <HiOutlineMail />,
          name: "email",
          required: name === "applicant",
          placeholder: t("modalApplicantIntervenantInputs.email"),
          value: values?.email,
          type: "input",
          normalize: value => value && value.toLowerCase(),
          col: 24,
        },
        {
          name: "invitation",
          label: t("modalApplicantIntervenantInputs.sendInvitation"),
          required: true,
          visible: name === "applicant",
          value: true,
          type: "checkbox-bool",
          col: 24,
        },
      ],
    },
    {
      children: [
        {
          col: 20,
          type: "component",
          component: () => (
            <Button
              size={"large"}
              onClick={() => {
                setOpen(false);
              }}
            >
              {t("modalApplicantIntervenantInputs.cancel")}
            </Button>
          ),
          align: "right",
        },
        {
          label: update
            ? t("modalApplicantIntervenantInputs.update")
            : t("modalApplicantIntervenantInputs.createAndInsert"),
          name: "send",
          value: "send",
          type: "submit",
          col: 4,
          align: "right",
        },
      ],
    },
  ];
};
